{
  "common": {
    "components": {
      "table": {
        "empty": {
          "title": "Sin resultados"
        },
        "pagination": {
          "page": "Página",
          "rowsPerPage": "Filas por página",
          "selected": "fila(s) seleccionada(s)",
          "of": "de"
        },
        "toolbar": {
          "filters": {
            "reset": "Restablecer filtros"
          },
          "columns": {
            "title": "Columnas",
            "search": "Buscar columnas",
            "empty": "No se encontraron columnas"
          }
        }
      },
      "calendar": {
        "navigation": {
          "events": "eventos"
        },
        "views": {
          "agenda": "Agenda",
          "month": "Mes",
          "week": "Semana",
          "day": "Día",
          "year": "Año"
        },
        "form": {
          "create": {
            "title": "Crear Evento",
            "description": "Completa los detalles para crear un nuevo evento.",
            "status": {
              "error": {
                "title": "Error al crear evento",
                "message": "No se pudo crear el evento"
              }
            }
          },
          "edit": {
            "title": "Editar Evento",
            "description": "Modifica los detalles del evento.",
            "status": {
              "error": {
                "title": "Error al editar evento",
                "message": "No se pudo editar el evento"
              }
            }
          },
          "patientNotFound": "Paciente no encontrado",
          "fields": {
            "title": {
              "label": "Título",
              "placeholder": "Consulta de seguimiento post-ortodoncia"
            },
            "patient": {
              "label": "Paciente",
              "placeholder": "Seleccionar paciente"
            },
            "doctor": {
              "label": "Doctor"
            },
            "startDate": {
              "label": "Fecha"
            },
            "endDate": {
              "label": "Fecha de Fin"
            },
            "color": {
              "label": "Color",
              "placeholder": "Seleccionar color del evento",
              "value": {
                "blue": "Azul",
                "green": "Verde",
                "red": "Rojo",
                "yellow": "Amarillo",
                "purple": "Morado",
                "orange": "Naranja"
              }
            },
            "duration": {
              "label": "Duración",
              "minutes": "minutos"
            }
          }
        },
        "settings": {
          "label": "Configuración del Calendario",
          "useDotBadge": "Usar insignia de punto",
          "use24HourFormat": "Usar formato de 24 horas",
          "clock24": "Reloj 24 horas",
          "clock12": "Reloj 12 horas",
          "defaultView": "Vista predeterminada",
          "day": "Día",
          "week": "Semana",
          "month": "Mes",
          "year": "Año",
          "agenda": "Agenda",
          "agendaGroupBy": "Agrupar vista agenda por",
          "date": "Fecha",
          "color": "Color"
        },
        "addEvent": "Agregar Evento",
        "appointmentMovedError": "Error al mover la cita",
        "appointmentMovedErrorDescription": "No se pudo mover la cita. Por favor, intente de nuevo.",
        "status": {
          "error": "Error al cargar el calendario",
          "noResultsFound": "No se encontraron resultados"
        },
        "weekAndDayView": {
          "todayAppointments": "Citas de Hoy",
          "noAppointments": "No hay citas ni consultas para hoy.",
          "weeklyViewNotAvailable": "La vista semanal no está disponible en dispositivos pequeños.",
          "switchToDailyOrMonthly": "Por favor cambia a vista diaria o mensual."
        },
        "event": {
          "untitled": "Evento sin título"
        },
        "agenda": {
          "at": "a las"
        },
        "filters": {
          "all": "Todos",
          "noUsersFound": "No se encontraron usuarios",
          "selectUser": "Seleccionar usuario",
          "clear": "Limpiar filtro"
        },
        "dayCell": {
          "more": "Más"
        },
        "monthView": {
          "eventBullet": "Bala de eventos",
          "day": "Día",
          "of": "de"
        },
        "yearView": {
          "notAvailable": "Vista anual no disponible",
          "switchToDailyOrMonthly": "Cambiar a diario o mensual"
        }
      },
      "inputFile": {
        "hasBeenRejected": "El archivo ha sido rechazado",
        "title": "Arrastre y suelte los archivos aquí",
        "Description": "O haga clic para navegar (máximo {{maxFiles}} archivos)",
        "browseFiles": "Navegar archivos",
        "filePreview": "Vista previa de archivo"
      },
      "search": {
        "placeholder": "Buscar..."
      },
      "notificationsDropdown": {
        "title": "Notificaciones",
        "created": "Creado el {{date}}"
      },
      "profileDropdown": {
        "items": {
          "language": "Idioma",
          "settings": "Configuración",
          "help": "Ayuda",
          "logout": "Cerrar sesión"
        }
      },
      "confirmDialog": {
        "delete": {
          "title": "Confirmar eliminación",
          "message": "¿Está seguro que desea eliminar este elemento? Esta acción no se puede deshacer.",
          "status": {
            "loading": {
              "title": "Eliminando",
              "message": "Por favor espere..."
            },
            "success": {
              "title": "Eliminado",
              "message": "Elemento eliminado exitosamente"
            },
            "error": {
              "title": "Error",
              "message": "Error al eliminar elemento"
            }
          }
        },
        "undoDelete": {
          "message": "¿Desea deshacer la eliminación?",
          "title": "Deshacer eliminación",
          "status": {
            "loading": {
              "title": "Deshaciendo",
              "message": "Por favor espere..."
            },
            "success": {
              "title": "Eliminado deshecho",
              "message": "Elemento restaurado exitosamente"
            },
            "error": {
              "title": "Error",
              "message": "Error al deshacer la eliminación"
            }
          }
        }
      },
      "commandMenu": {
        "search": {
          "title": "Buscar",
          "description": "Buscar o navegar",
          "placeholder": "Escriba un comando o busque...",
          "empty": "No se encontraron resultados"
        },
        "theme": {
          "title": "Tema",
          "options": {
            "light": "Claro",
            "dark": "Oscuro",
            "system": "Sistema"
          }
        }
      },
      "sidebar": {
        "branches": {
          "label": "Sucursales",
          "buttons": {
            "select": "Seleccionar sucursal",
            "add": "Agregar sucursal"
          }
        },
        "groups": {
          "dashboard": "Dashboard",
          "settings": "Configuración"
        },
        "items": {
          "appointments": "Citas",
          "invoices": "Facturación",
          "doctors": "Doctores",
          "branches": "Sucursales",
          "formularies": "Formularios",
          "overview": "Tablero",
          "patients": "Pacientes",
          "procedures": "Procedimientos",
          "proceduresTypes": "Tipos de Procedimientos"
        }
      },
      "formBuilder": {
        "tabs": {
          "edit": "Editar",
          "preview": "Vista previa"
        },
        "empty": {
          "title": "No hay elementos agregados",
          "description": "Agrega elementos a tu formulario para comenzar"
        },
        "title": "Elementos del formulario",
        "searchPlaceholder": "Buscar elementos...",
        "groups": {
          "display": "Visualización",
          "field": "Campo"
        },
        "elementNames": {
          "Text": "Texto",
          "Separator": "Separador",
          "Input": "Entrada",
          "Textarea": "Área de texto",
          "Select": "Selección",
          "Checkbox": "Casilla",
          "DatePicker": "Selector de fecha",
          "MultiSelect": "Selección múltiple",
          "RadioGroup": "Radio",
          "ToggleGroup": "Grupo de opciones"
        },
        "templates": {
          "label": "Plantillas",
          "placeholder": "Seleccionar una plantilla",
          "names": {
            "empty": "Vacío",
            "dentalPatientRegistration": "Registro de paciente dental",
            "dentalTreatmentPlan": "Plan de tratamiento dental"
          }
        },
        "preview": {
          "empty": "Agrega elementos al formulario para ver la vista previa",
          "submit": "Enviar"
        },
        "fieldCustomization": {
          "title": "Atributos del campo",
          "description": "Personalizar el campo {{fieldType}}",
          "options": {
            "add": "Agregar opción",
            "empty": "Sin opciones. Haz clic en \"Agregar opción\" para comenzar.",
            "placeholder": "Etiqueta de opción"
          },
          "selectPlaceholder": "Seleccionar",
          "selectItem": "Seleccionar elemento",
          "selectItems": "Seleccionar elementos",
          "fields": {
            "textContent": "Contenido de texto",
            "textType": "Tipo de texto",
            "deprecated": "Este elemento está obsoleto. Usa el elemento Texto en su lugar.",
            "label": "Etiqueta",
            "placeholder": "Marcador de posición",
            "description": "Descripción",
            "selectionMode": "Modo de selección",
            "inputType": "Tipo de entrada",
            "required": "Requerido",
            "disabled": "Deshabilitado"
          }
        }
      }
    },
    "actions": {
      "create": "Crear",
      "edit": "Editar",
      "delete": "Eliminar",
      "cancel": "Cancelar",
      "export": "Exportar",
      "refresh": "Actualizar",
      "save": "Guardar",
      "view": "Ver",
      "leave": "Abandonar",
      "accept": "Aceptar"
    },
    "errors": {
      "validation_not_unique": "Este valor ya está en uso",
      "validation_required": "Este campo es obligatorio",
      "validation_email": "Formato de email inválido",
      "invalid_credentials": "Email o contraseña inválidos",
      "generic": "Ocurrió un error. Por favor intenta de nuevo.",
      "Too Many Requests": "Demasiados pedidos. Por favor intenta de nuevo más tarde.",
      "LIMIT.BRANCH.REACHED": "Has alcanzado el límite de sucursales. Actualiza tu plan para agregar más sucursales.",
      "LIMIT.PATIENT.REACHED": "Has alcanzado el límite de pacientes. Actualiza tu plan para agregar más pacientes.",
      "LIMIT.APPOINTMENT.REACHED": "Has alcanzado el límite de citas. Actualiza tu plan para agendar más citas.",
      "LIMIT.PROCEDURE_TYPE.REACHED": "Has alcanzado el límite de tipos de procedimientos. Actualiza tu plan para agregar más tipos.",
      "LIMIT.FORMULARY.REACHED": "Has alcanzado el límite de formularios. Actualiza tu plan para crear más formularios.",
      "LIMIT.STORAGE.REACHED": "Has alcanzado el límite de almacenamiento. Actualiza tu plan para obtener más almacenamiento.",
      "LIMIT.DOCTOR.REACHED": "Has alcanzado el límite de doctores. Actualiza tu plan para agregar más doctores.",
      "LIMIT.INVITATION.REACHED": "Has alcanzado el límite de invitaciones. Actualiza tu plan para invitar más doctores.",
      "SUBSCRIPTION.NOT_FOUND": "Suscripción no encontrada.",
      "SUBSCRIPTION.INACTIVE": "La suscripción está inactiva. Por favor renueva tu suscripción.",
      "SUBSCRIPTION.CANCELLED": "La suscripción ha sido cancelada.",
      "SUBSCRIPTION.EXPIRED": "La suscripción ha expirado.",
      "SUBSCRIPTION.TRIAL_EXPIRED": "La suscripción de prueba ha expirado.",
      "SUBSCRIPTION.PLAN_NOT_FOUND": "Plan de suscripción no encontrado.",
      "DEVICE.INFO.INSUFFICIENT": "La información del dispositivo es insuficiente.",
      "DEVICE.COLLECTION.NOT_FOUND": "Colección de dispositivos no encontrada.",
      "DEVICE.QUERY.FAILED": "Error al consultar dispositivos.",
      "DEVICE.SAVE.FAILED": "Error al guardar dispositivo.",
      "DEVICE.UPDATE.FAILED": "Error al actualizar dispositivo.",
      "INVITATION.ID_REQUIRED": "El ID de invitación es obligatorio.",
      "INVITATION.INVALID_REQUEST": "Solicitud de invitación inválida.",
      "INVITATION.FIRST_NAME_REQUIRED": "El nombre es obligatorio.",
      "INVITATION.LAST_NAME_REQUIRED": "El apellido es obligatorio.",
      "INVITATION.PHONE_REQUIRED": "El número de teléfono es obligatorio.",
      "INVITATION.PASSWORD_REQUIRED": "La contraseña es obligatoria.",
      "INVITATION.PASSWORD_MISMATCH": "Las contraseñas no coinciden.",
      "INVITATION.PASSWORD_WEAK": "La contraseña es muy débil. Usa al menos 8 caracteres con letras y números.",
      "INVITATION.NOT_FOUND": "Invitación no encontrada.",
      "INVITATION.ALREADY_ACCEPTED": "La invitación ya ha sido aceptada.",
      "INVITATION.ALREADY_REJECTED": "La invitación ya ha sido rechazada.",
      "INVITATION.INVALID_TRANSITION": "Este cambio de estado no está permitido para el estado actual de la invitación.",
      "INVITATION.EXPIRED": "La invitación ha expirado.",
      "INVITATION.EMAIL_NOT_FOUND": "No se encontró invitación para este email.",
      "INVITATION.DOCTOR_COLL_NOT_FOUND": "Colección de doctores no encontrada.",
      "INVITATION.CREATE_DOCTOR_FAILED": "Error al crear cuenta de doctor.",
      "INVITATION.ACCEPT_FAILED": "Error al aceptar invitación.",
      "INVITATION.RESEND_FAILED": "Error al reenviar invitación.",
      "INVITATION.ALREADY_MEMBER": "Este usuario ya es miembro.",
      "INVITATION.ALREADY_PENDING": "Ya hay una invitación pendiente para este email.",
      "AUTH.EMAIL_REQUIRED": "El email es obligatorio.",
      "AUTH.INVALID_REQUEST": "Solicitud de autenticación inválida.",
      "AUTH.CODE_NOT_FOUND": "Código de verificación no encontrado o inválido.",
      "AUTH.CODE_EXPIRED": "El código de verificación ha expirado.",
      "AUTH.MISSING_AUTH": "Se requiere autenticación.",
      "AUTH.UPDATE_FAILED": "Error al actualizar autenticación.",
      "AUTH.DELETE_FAILED": "Error al eliminar autenticación.",
      "BRANCH.ID_REQUIRED": "El ID de sucursal es obligatorio.",
      "BRANCH.NOT_MEMBER": "No eres miembro de esta sucursal.",
      "BRANCH.OWNER_CANNOT_LEAVE": "El propietario de la sucursal no puede abandonarla.",
      "BRANCH.LEAVE_FAILED": "Error al abandonar la sucursal.",
      "BRANCH.NOT_AUTHORIZED": "No tienes autorización para realizar esta acción.",
      "BRANCH.MEMBER_NOT_FOUND": "Miembro de sucursal no encontrado.",
      "BRANCH.CANNOT_REMOVE_OWNER": "No se puede remover al propietario de la sucursal.",
      "BRANCH.REMOVE_FAILED": "Error al remover miembro de la sucursal.",
      "BRANCH.ALREADY_MEMBER": "El usuario ya es miembro de esta sucursal.",
      "SMS.PHONE_REQUIRED": "El número de teléfono es obligatorio.",
      "SMS.SEND_FAILED": "Error al enviar SMS.",
      "SMS.COLL_NOT_FOUND": "Colección de SMS no encontrada.",
      "SMS.CODE_NOT_FOUND": "Código de verificación no encontrado.",
      "SMS.CODE_UPDATE_FAILED": "Error al actualizar código de verificación.",
      "SMS.CODE_SAVE_FAILED": "Error al guardar código de verificación.",
      "WEBHOOK.INVALID_DATA": "Datos de webhook inválidos.",
      "WEBHOOK.MISSING_FIELDS": "Faltan campos requeridos en el webhook.",
      "WEBHOOK.INVALID_SIG": "Firma de webhook inválida.",
      "WEBHOOK.READ_FAILED": "Error al leer webhook.",
      "Failed to authenticate": "Por favor verifica tu email y contraseña e intenta nuevamente.",
      "The request requires valid record authorization token": "Tu sesión ha expirado. Por favor inicia sesión nuevamente.",
      "The request requires valid admin authorization token to be set": "La sesión de administrador ha expirado. Por favor inicia sesión nuevamente.",
      "The operation is forbidden": "Esta acción no está permitida.",
      "Something went wrong while processing your request": "Algo salió mal. Por favor intenta de nuevo.",
      "Something went wrong": "Algo salió mal. Por favor intenta de nuevo.",
      "The requested resource wasn't found": "El recurso solicitado no fue encontrado o no tienes suficientes permisos.",
      "Only superusers can perform this action": "Solo los administradores pueden realizar esta acción.",
      "Failed to create record": "Error al crear el registro.",
      "Failed to delete record": "Error al eliminar el registro.",
      "Missing required value": "Este campo es obligatorio.",
      "Invalid filter": "Criterio de filtro inválido.",
      "Your email is not verified": "Tu dirección de correo electrónico no ha sido verificada.",
      "Invalid login credentials": "Email o contraseña inválidos.",
      "UNAUTHORIZED": "No estás autorizado para realizar esta acción.",
      "PERMISSION.OWNER_ONLY": "Solo el propietario de la sucursal puede realizar esta acción.",
      "DELETE_BLOCKED_BY_RELATION": "No se puede eliminar: este registro está referenciado por otros registros."
    },
    "status": {
      "refreshing": "Actualizando...",
      "loading": "Cargando...",
      "pageNotFound": {
        "title": "Página no encontrada",
        "message": "La página que buscas no existe.",
        "action": "Volver al inicio"
      },
      "pageError": {
        "title": "Ha ocurrido un error",
        "message": "Ocurrió un error al cargar la página.",
        "action": "Reintentar"
      }
    }
  },
  "modules": {
    "auth": {
      "common": {
        "fields": {
          "email": {
            "label": "Correo electrónico",
            "placeholder": "jhondoe@email.com"
          },
          "password": {
            "label": "Contraseña",
            "placeholder": "Cree una contraseña segura"
          },
          "phoneNumber": {
            "label": "Número de teléfono",
            "placeholder": "+1 000 000 000"
          }
        },
        "buttons": {
          "back": "Volver al inicio",
          "backToLogin": "Volver al inicio de sesión"
        }
      },
      "login": {
        "title": "Iniciar sesión",
        "buttons": {
          "submit": "Iniciar sesión",
          "google": "Iniciar sesión con Google",
          "register": {
            "question": "¿No tienes una cuenta?",
            "answer": "Crear una cuenta"
          },
          "forgotPassword": "¿Olvidaste tu contraseña?"
        },
        "status": {
          "loading": {
            "title": "Iniciando sesión",
            "message": "Por favor espere mientras iniciamos su sesión..."
          },
          "success": {
            "title": "Sesión iniciada",
            "message": "Será redirigido al panel en breve."
          },
          "error": {
            "title": "Error al iniciar sesión",
            "message": "Por favor verifique su correo y contraseña e intente nuevamente."
          }
        }
      },
      "forgotPassword": {
        "title": "¿Olvidaste tu contraseña?",
        "buttons": {
          "submit": "Enviar instrucciones de restablecimiento",
          "register": {
            "question": "¿No tienes una cuenta?",
            "answer": "Crear una cuenta"
          }
        },
        "status": {
          "loading": {
            "title": "Enviando instrucciones",
            "message": "Por favor espere mientras enviamos las instrucciones..."
          },
          "success": {
            "title": "Instrucciones enviadas",
            "message": "Revisa tu correo electrónico para las instrucciones de restablecimiento."
          },
          "error": {
            "title": "Error al enviar instrucciones",
            "message": "Por favor verifique su correo e intente nuevamente."
          }
        }
      },
      "register": {
        "title": "Crear cuenta",
        "fields": {
          "passwordConfirm": {
            "label": "Confirmar contraseña",
            "placeholder": "Repita su contraseña"
          }
        },
        "buttons": {
          "submit": "Crear cuenta",
          "login": {
            "question": "¿Ya tienes una cuenta?",
            "answer": "Iniciar sesión"
          }
        },
        "status": {
          "loading": {
            "title": "Creando cuenta",
            "message": "Por favor espere mientras creamos su cuenta..."
          },
          "success": {
            "title": "Cuenta creada exitosamente",
            "message": "Ahora puedes iniciar sesión con tu correo electrónico y contraseña."
          },
          "error": {
            "title": "Error al registrarse",
            "message": "Por favor verifique sus datos e intente nuevamente."
          }
        }
      },
      "sendVerification": {
        "title": "Enviar código de verificación",
        "buttons": {
          "submit": "Enviar código de verificación",
          "logout": "Cerrar sesión"
        },
        "status": {
          "loading": {
            "title": "Enviando código",
            "message": "Por favor espere mientras enviamos el código..."
          },
          "success": {
            "title": "Código enviado",
            "message": "Revisa tu correo electrónico para el código de verificación."
          },
          "error": {
            "title": "Error al enviar código",
            "message": "Por favor verifique su correo e intente nuevamente."
          }
        }
      },
      "verifyPhone": {
        "title": "Verificar número de teléfono",
        "fields": {
          "otp": {
            "label": "Código de verificación"
          }
        },
        "buttons": {
          "submit": "Verificar número",
          "resendCode": "Reenviar código",
          "logout": "Cerrar sesión"
        },
        "status": {
          "loading": {
            "title": "Verificando número",
            "message": "Por favor espere mientras verificamos su número..."
          },
          "success": {
            "title": "Número verificado",
            "message": "Su número ha sido verificado exitosamente."
          },
          "error": {
            "title": "Error al verificar número",
            "message": "Por favor verifique el código e intente nuevamente."
          }
        }
      },
      "resendCode": {
        "status": {
          "loading": {
            "title": "Reenviando código",
            "message": "Por favor espere mientras reenviamos el código..."
          },
          "success": {
            "title": "Código reenviado",
            "message": "El código ha sido reenviado exitosamente."
          },
          "error": {
            "title": "Error al reenviar código",
            "message": "Por favor intente nuevamente más tarde."
          }
        }
      }
    },
    "dashboard": {
      "charts": {
        "statistics": {
          "title": "Estadísticas de Rendimiento",
          "periods": {
            "currentMonth": "Mes Actual",
            "currentYear": "Año Actual"
          },
          "metrics": {
            "revenue": "Ingresos Totales",
            "patients": "Pacientes nuevos",
            "appointments": "Citas totales",
            "procedures": "Procedimientos totales",
            "invoices": "Facturas"
          }
        },
        "newPatients": {
          "title": "Nuevos Pacientes",
          "description": "Lista de pacientes que han sido agregados recientemente",
          "empty": {
            "title": "No hay nuevos pacientes",
            "message": "Aún no hay pacientes que han sido agregados recientemente"
          }
        },
        "overview": {
          "title": "Resumen de Actividades",
          "description": "Estadísticas mensuales de actividades del doctor",
          "quantity": "Cantidad",
          "modules": {
            "revenue": "Ingresos",
            "patients": "Pacientes",
            "appointments": "Citas",
            "appointmentsCancelled": "Citas Canceladas",
            "procedures": "Procedimientos",
            "invoicesGenerated": "Facturas Generadas",
            "invoicesPaid": "Facturas Pagadas",
            "invoicesCancelled": "Facturas Canceladas",
            "avgAppointmentDuration": "Duración Media de Cita"
          },
          "error": {
            "title": "Error al cargar estadísticas",
            "message": "Ocurrió un error al cargar las estadísticas. Por favor, inténtalo de nuevo más tarde."
          }
        },
        "monthComparison": {
          "title": "Comparación Mensual",
          "description": "Comparación de estadísticas entre meses",
          "thisMonth": "Este Mes",
          "lastMonth": "Mes Anterior",
          "comparedToLastMonth": "Comparado con el mes anterior"
        }
      },
      "title": "Dashboard"
    },
    "invoices": {
      "title": "Facturación",
      "common": {
        "terms": {
          "statusOptions": {
            "generated": "Generada",
            "paid": "Pagada",
            "cancelled": "Cancelada"
          },
          "itemStatusOptions": {
            "pending": "Pendiente",
            "paid": "Pagado"
          }
        }
      },
      "table": {
        "columns": {
          "doctor": "Doctor",
          "patient": "Paciente",
          "status": "Estado",
          "total": "Total",
          "created": "Creado el",
          "search": "Buscar"
        }
      },
      "forms": {
        "edit": {
          "title": "Edit Invoice",
          "description": "Update invoice details",
          "status": {
            "loading": {
              "title": "Cargando factura",
              "message": "Por favor espere mientras cargamos la factura..."
            },
            "success": {
              "title": "Factura cargada",
              "message": "La factura se ha cargado exitosamente"
            },
            "error": {
              "title": "Error al cargar factura",
              "message": "Ocurrió un error al cargar la factura"
            }
          }
        },
        "create": {
          "title": "Crear factura",
          "description": "Rellene los detalles para crear una nueva factura",
          "status": {
            "error": {
              "message": "Ocurrió un error al crear la factura",
              "title": "Error al crear factura"
            },
            "loading": {
              "message": "Por favor, espere mientras creamos la factura...",
              "title": "Creando factura..."
            },
            "success": {
              "message": "La factura se ha creado exitosamente",
              "title": "Factura creada"
            }
          }
        },
        "fields": {
          "patient": {
            "label": "Paciente",
            "placeholder": "Selecciona paciente"
          },
          "procedure": {
            "label": "Procedimiento",
            "placeholder": "Nombre del procedimiento"
          },
          "price": {
            "label": "Precio",
            "placeholder": "Precio del procedimiento"
          },
          "status": {
            "label": "Estado",
            "placeholder": "Selecciona estado"
          }
        }
      },
      "actions": {
        "addItem": {
          "title": "Agregar artículo",
          "description": "No hay artículos en esta factura. Clic en 'Agregar artículo' para añadir uno."
        },
        "duplicateItem": {
          "title": "Duplicar artículo"
        },
        "print": {
          "title": "Imprimir factura",
          "status": {
            "loading": {
              "title": "Imprimiendo factura",
              "message": "Por favor espere mientras imprimimos la factura..."
            },
            "success": {
              "title": "Factura impresa",
              "message": "La factura se ha impreso correctamente"
            },
            "error": {
              "title": "Error al imprimir factura",
              "message": "Ocurrió un error al imprimir la factura"
            },
            "noItems": {
              "title": "Sin artículos",
              "message": "No hay artículos para imprimir"
            }
          }
        }
      }
    },
    "appointments": {
      "title": "citas"
    },
    "doctors": {
      "title": "Doctores",
      "table": {
        "columns": {
          "search": "Buscar",
          "firstName": "Nombre",
          "lastName": "Apellido",
          "email": "Correo electrónico",
          "phone": "Teléfono",
          "created": "Creado el",
          "doctor": "Doctor",
          "photo": "Foto"
        }
      },
      "forms": {
        "create": {
          "title": "Crear Doctor",
          "description": "Complete los detalles para crear un nuevo doctor",
          "status": {
            "loading": {
              "title": "Creando doctor",
              "message": "Por favor espere mientras creamos el doctor..."
            },
            "success": {
              "title": "Doctor creado",
              "message": "El doctor ha sido creado exitosamente"
            },
            "error": {
              "title": "Error al crear doctor",
              "message": "Ocurrió un error al crear el doctor"
            }
          }
        },
        "edit": {
          "title": "Editar Doctor",
          "description": "Actualizar detalles del doctor",
          "status": {
            "loading": {
              "title": "Actualizando doctor",
              "message": "Por favor espere mientras actualizamos el doctor..."
            },
            "success": {
              "title": "Doctor actualizado",
              "message": "El doctor ha sido actualizado exitosamente"
            },
            "error": {
              "title": "Error al actualizar doctor",
              "message": "Ocurrió un error al actualizar el doctor"
            }
          }
        },
        "fields": {
          "photo": {
            "label": "Foto de perfil"
          },
          "email": {
            "label": "Correo electrónico",
            "placeholder": "Ingrese el correo electrónico del doctor"
          },
          "firstName": {
            "label": "Nombre",
            "placeholder": "Ingrese el nombre del doctor"
          },
          "lastName": {
            "label": "Apellido",
            "placeholder": "Ingrese el apellido del doctor"
          },
          "phoneNumber": {
            "label": "Número de teléfono",
            "placeholder": "Ingrese el número de teléfono del doctor"
          }
        }
      },
      "actions": {
        "removeFromBranch": "Remover de la sucursal"
      },
      "removeFromBranch": {
        "status": {
          "loading": {
            "title": "Removiendo de la sucursal",
            "message": "Por favor espere..."
          },
          "success": {
            "title": "Removido de la sucursal",
            "message": "El doctor ha sido removido de la sucursal"
          },
          "error": {
            "title": "Error al remover de la sucursal",
            "message": "Ocurrió un error al remover al doctor de la sucursal"
          }
        }
      }
    },
    "branches": {
      "title": "Sucursales",
      "terms": {
        "role": "Rol",
        "main": "Sucursal principal",
        "owner": "Propietario",
        "guest": "Invitado",
        "settings": "Configuración"
      },
      "table": {
        "columns": {
          "image": "Imagen",
          "name": "Nombre",
          "phone": "Teléfono",
          "email": "Correo electrónico",
          "doctor": "Doctor",
          "role": "Rol",
          "created": "Creada el",
          "search": "Buscar"
        }
      },
      "forms": {
        "edit": {
          "title": "Editar Sucursal",
          "description": "Actualizar detalles de la sucursal",
          "status": {
            "loading": {
              "title": "Actualizando sucursal",
              "message": "Por favor espere mientras actualizamos la sucursal..."
            },
            "success": {
              "title": "Sucursal actualizada",
              "message": "La sucursal ha sido actualizada exitosamente"
            },
            "error": {
              "title": "Error al actualizar",
              "message": "Ocurrió un error al actualizar la sucursal"
            }
          }
        },
        "create": {
          "title": "Crear sucursal",
          "description": "Rellene los detalles para crear una nueva sucursal",
          "status": {
            "loading": {
              "title": "Creando sucursal",
              "message": "Por favor espere mientras creamos la sucursal..."
            },
            "success": {
              "title": "Sucursal creada",
              "message": "La sucursal ha sido creada exitosamente"
            },
            "error": {
              "title": "Error al crear",
              "message": "Ocurrió un error al crear la sucursal"
            }
          }
        },
        "fields": {
          "name": {
            "label": "Nombre de la sucursal",
            "placeholder": "Sucursal Norte"
          },
          "phoneNumber": {
            "label": "Número de teléfono",
            "placeholder": "+1 000 000 000"
          },
          "address": {
            "label": "Dirección",
            "placeholder": "Calle, número y ciudad"
          },
          "email": {
            "label": "Correo Electrónico",
            "placeholder": "jhondoe@email.com"
          },
          "image": {
            "label": "Imagen"
          },
          "file": {
            "label": "Archivo"
          }
        }
      }
    },
    "support": {
      "title": "Soporte",
      "description": "Envía un ticket de soporte para asistencia",
      "form": {
        "fields": {
          "email": {
            "label": "Correo electrónico",
            "placeholder": "Ingresa tu correo electrónico"
          },
          "subject": {
            "label": "Asunto",
            "placeholder": "Ingresa el asunto del ticket"
          },
          "message": {
            "label": "Mensaje",
            "placeholder": "Escribe tu mensaje aquí"
          }
        },
        "status": {
          "loading": {
            "title": "Cargando tickets",
            "message": "Por favor espere..."
          },
          "success": {
            "title": "Éxito",
            "message": "Tickets cargados exitosamente"
          },
          "error": {
            "title": "Error",
            "message": "Error al cargar tickets"
          }
        }
      }
    },
    "formularies": {
      "responses": {
        "create": {
          "status": {
            "loading": {
              "title": "Creando respuesta",
              "message": "Por favor espera mientras creamos la respuesta..."
            },
            "success": {
              "title": "Respuesta creada",
              "message": "La respuesta ha sido creada correctamente"
            },
            "error": {
              "title": "Error al crear la respuesta"
            }
          }
        },
        "update": {
          "status": {
            "loading": {
              "title": "Actualizando respuesta",
              "message": "Por favor espera mientras actualizamos la respuesta..."
            },
            "success": {
              "title": "Respuesta actualizada",
              "message": "La respuesta ha sido actualizada correctamente"
            },
            "error": {
              "title": "Error al actualizar la respuesta"
            }
          }
        }
      },
      "title": "formularios",
      "table": {
        "columns": {
          "name": "Nombre",
          "description": "Descripción",
          "created": "Creado el",
          "doctor": "Doctor",
          "search": "Buscar"
        }
      },
      "forms": {
        "edit": {
          "title": "Editar Formulario",
          "description": "Actualizar detalles del formulario",
          "status": {
            "loading": {
              "title": "Actualizando formulario",
              "message": "Por favor espere mientras actualizamos el formulario..."
            },
            "success": {
              "title": "Formulario actualizado",
              "message": "El formulario ha sido actualizado exitosamente"
            },
            "error": {
              "message": "Ocurrió un error al crear el formulario",
              "title": "Error al actualizar formulario"
            }
          }
        },
        "create": {
          "title": "Crear Formulario",
          "description": "Complete los detalles para crear un nuevo formulario",
          "status": {
            "loading": {
              "title": "Creando formulario",
              "message": "Por favor espere mientras creamos el formulario..."
            },
            "success": {
              "title": "Formulario creado",
              "message": "El formulario ha sido creado exitosamente"
            },
            "error": {
              "title": "Error al crear formulario",
              "message": "Ocurrió un error al crear el formulario"
            }
          }
        },
        "fields": {
          "name": {
            "label": "Nombre del formulario",
            "placeholder": "Formulario de Anamnesis"
          },
          "description": {
            "label": "Descripción",
            "placeholder": "Este documento recopila los antecedentes médicos y odontológicos del paciente antes de iniciar cualquier examen clínico físico."
          },
          "fields": {
            "label": "Campos",
            "placeholder": "Seleccione los campos del formulario"
          },
          "closeConfirm": {
            "title": "¿Estás seguro que deseas cerrar?",
            "description": "Los cambios sin guardar se perderán."
          }
        }
      },
      "actions": {
        "addFields": {
          "title": "Agregar campos"
        }
      }
    },
    "patients": {
      "table": {
        "columns": {
          "photo": "Foto",
          "firstName": "Nombre",
          "lastName": "Apellido",
          "email": "Correo electrónico",
          "phoneNumber": "Teléfono",
          "doctor": "Doctor",
          "created": "Creado el",
          "search": "Buscar"
        }
      },
      "details": {
        "subtitle": "Información del paciente",
        "email": "Correo electrónico",
        "phone": "Teléfono",
        "birthDate": "Fecha de nacimiento",
        "createdAt": "Fecha de registro"
      },
      "tabs": {
        "appointments": "Citas",
        "medicalHistory": "Historial médico",
        "documents": "Documentos",
        "invoices": "Facturas",
        "odontogram": "Odontograma",
        "procedures": "Procedimientos"
      },
      "medicalHistory": {
        "selectMedicalForm": "Seleccionar formulario médico",
        "selectMedicalFormDescription": "Seleccione el formulario médico para asociar con la cita.",
        "search": "Buscar",
        "noFormularies": "No se encontraron formularios",
        "clearSearch": "Limpiar búsqueda",
        "noDescription": "No hay descripción disponible"
      },
      "odontogram": {
        "buttons": {
          "clear": "Limpiar",
          "save": "Guardar",
          "undo": "Deshacer"
        },
        "legend": {
          "title": "Legenda"
        },
        "create": {
          "status": {
            "duplicate": {
              "title": "Ya existe un odontograma para este paciente",
              "message": "Se creó en otra sesión. Vuelve a intentar guardar para actualizarlo."
            },
            "error": {
              "title": "Error al crear el odontograma",
              "message": "Ocurrió un error al crear el odontograma."
            },
            "loading": {
              "title": "Creando odontograma...",
              "message": "Por favor espera mientras creamos el odontograma."
            },
            "success": {
              "title": "Odontograma creado",
              "message": "El odontograma ha sido creado correctamente."
            }
          }
        },
        "update": {
          "status": {
            "error": {
              "title": "Error al actualizar el odontograma",
              "message": "Ocurrió un error al actualizar el odontograma."
            },
            "loading": {
              "title": "Actualizando odontograma...",
              "message": "Por favor espera mientras actualizamos el odontograma."
            },
            "success": {
              "title": "Odontograma actualizado",
              "message": "El odontograma ha sido actualizado correctamente."
            }
          }
        }
      },
      "forms": {
        "edit": {
          "title": "Editar Paciente",
          "description": "Actualizar detalles del paciente",
          "status": {
            "loading": {
              "title": "Actualizando paciente",
              "message": "Por favor espere mientras actualizamos el paciente..."
            },
            "success": {
              "title": "Paciente actualizado",
              "message": "El paciente ha sido actualizado exitosamente"
            },
            "error": {
              "title": "Error al actualizar",
              "message": "Ocurrió un error al actualizar el paciente"
            }
          }
        },
        "create": {
          "title": "Crear Paciente",
          "description": "Complete los detalles para crear un nuevo paciente",
          "status": {
            "loading": {
              "title": "Creando paciente",
              "message": "Por favor espere mientras creamos el paciente..."
            },
            "success": {
              "title": "Paciente creado",
              "message": "El paciente ha sido creado exitosamente"
            },
            "error": {
              "title": "Error al crear",
              "message": "Ocurrió un error al crear el paciente"
            }
          }
        },
        "fields": {
          "firstName": {
            "label": "Nombre",
            "placeholder": "Juan Pablo"
          },
          "lastName": {
            "label": "Apellido",
            "placeholder": "García Pérez"
          },
          "email": {
            "label": "Correo electrónico",
            "placeholder": "juanpablo@email.com"
          },
          "phoneNumber": {
            "label": "Número de teléfono",
            "placeholder": "+1 (000) 000-0000"
          },
          "bornDate": {
            "label": "Fecha de nacimiento",
            "placeholder": "Fecha de nacimiento del paciente"
          },
          "doctor": {
            "label": "Doctor",
            "placeholder": "Seleccione el doctor"
          },
          "photo": {
            "label": "Foto",
            "placeholder": "Ingrese la foto del paciente"
          }
        }
      },
      "title": "pacientes"
    },
    "proceduresTypes": {
      "title": "Tipos de procedimientos",
      "table": {
        "columns": {
          "name": "Nombre",
          "description": "Descripción",
          "duration": "Duración",
          "created": "Fecha de creación",
          "search": "Buscar"
        }
      },
      "forms": {
        "edit": {
          "title": "Actualizar tipo de procedimiento",
          "description": "Actualizar los detalles del tipo de procedimiento",
          "status": {
            "error": {
              "message": "Ocurrió un error al cargar el tipo de procedimiento",
              "title": "Error al cargar el tipo de procedimiento"
            },
            "loading": {
              "title": "Cargando tipo de procedimiento",
              "message": "Por favor espera mientras cargamos el tipo de procedimiento..."
            },
            "success": {
              "title": "Tipo de procedimiento cargado",
              "message": "El tipo de procedimiento se ha cargado correctamente"
            }
          }
        },
        "fields": {
          "name": {
            "label": "Nombre",
            "placeholder": "Consulta general"
          },
          "description": {
            "label": "Descripción",
            "placeholder": "Revisión de rutina y diagnóstico inicial del paciente."
          },
          "duration": {
            "label": "Duración",
            "placeholder": "Duración del tipo de procedimiento"
          }
        },
        "create": {
          "title": "Crear tipo de procedimiento",
          "description": "Crear un nuevo tipo de procedimiento",
          "status": {
            "loading": {
              "title": "Creando tipo de procedimiento",
              "message": "Por favor espera mientras creamos el tipo de procedimiento..."
            },
            "success": {
              "title": "Tipo de procedimiento creado",
              "message": "El tipo de procedimiento ha sido creado correctamente"
            },
            "error": {
              "title": "Error al crear el tipo de procedimiento",
              "message": "Ocurrió un error al crear el tipo de procedimiento"
            }
          }
        }
      }
    },
    "procedures": {
      "title": "procedimientos",
      "table": {
        "columns": {
          "search": "Buscar",
          "type": "Tipo",
          "doctor": "Doctor",
          "patient": "Paciente",
          "created": "Creado el"
        }
      },
      "forms": {
        "edit": {
          "title": "Actualizar procedimiento",
          "description": "Actualizar datos del procedimiento",
          "status": {
            "loading": {
              "title": "Cargando procedimiento",
              "message": "Por favor espere mientras cargamos el procedimiento..."
            },
            "success": {
              "title": "Procedimiento cargado",
              "message": "El procedimiento se ha cargado exitosamente"
            },
            "error": {
              "title": "Error al cargar procedimiento",
              "message": "Ocurrió un error al cargar el procedimiento"
            }
          }
        },
        "create": {
          "title": "Crear procedimiento",
          "description": "Por favor, rellene los campos requeridos para crear el procedimiento",
          "status": {
            "loading": {
              "title": "Creando procedimiento",
              "message": "Por favor espere mientras creamos el procedimiento..."
            },
            "success": {
              "title": "Procedimiento creado",
              "message": "El procedimiento ha sido creado exitosamente"
            },
            "error": {
              "title": "Error al crear procedimiento",
              "message": "Ocurrió un error al crear el procedimiento"
            }
          }
        },
        "fields": {
          "doctor": {
            "label": "Doctor",
            "placeholder": "Seleccione Doctor"
          },
          "type": {
            "label": "Tipo de procedimiento",
            "placeholder": "Seleccionar el tipo de procedimiento"
          },
          "patient": {
            "label": "Paciente",
            "placeholder": "Seleccionar paciente"
          }
        }
      }
    },
    "settings": {
      "title": "Configuración",
      "billing": {
        "title": "Configuración de Facturación",
        "description": "Gestiona la información de facturación y métodos de pago",
        "plan": "Plan",
        "monthly": "Mensual",
        "subscription": "Suscripción",
        "nextBillingDate": "Próxima fecha de facturación",
        "paymentMethod": "Método de pago",
        "manageSubscription": "Gestionar suscripción",
        "subscriptionTracker": {
          "title": "Estado de Suscripción",
          "trial": "Período de Prueba",
          "trialDescription": "Actualiza para desbloquear todas las funciones",
          "active": "Activo",
          "activeDescription": "Tu suscripción está activa y funcionando correctamente.",
          "activeStatus": "Activo",
          "pausedStatus": "Pausado",
          "endsAt": "Termina Pronto",
          "endsAtDescription": "Tu suscripción está por terminar.",
          "daysLeft": "días restantes",
          "startedIn": "Iniciado en",
          "endsAtDate": "Termina en",
          "upgrade": "Actualizar",
          "expired": "Expirado"
        },
        "planLimits": {
          "title": "Uso del Plan",
          "description": "Uso actual de recursos de tu plan",
          "upgrade": "Actualizar Plan",
          "unlimited": "Ilimitado",
          "resources": {
            "patients": "Pacientes",
            "branches": "Sucursales",
            "doctors": "Doctores",
            "appointmentsMonth": "Citas (mes)",
            "procedureTypes": "Tipos procedimientos",
            "formularies": "Formularios",
            "storageMB": "Almacenamiento (MB)"
          },
          "alerts": {
            "limitReached": "Límite alcanzado",
            "nearLimit": "Cerca del límite",
            "upgradeMessage": "Has alcanzado el límite de tu plan. Actualiza para continuar."
          }
        }
      },
      "subscription": {
        "expired": {
          "title": "Suscripción expirada",
          "message": "Tu suscripción ha terminado. Renueva tu plan para continuar usando todas las funciones."
        },
        "past_due": {
          "title": "Pago vencido",
          "message": "Tienes un pago pendiente. Actualiza tu método de pago para evitar la suspensión del servicio."
        },
        "unpaid": {
          "title": "Pago requerido",
          "message": "Tu suscripción no está pagada. Realiza el pago para continuar usando el servicio."
        },
        "cancelled": {
          "title": "Suscripción cancelada",
          "message": "Tu suscripción fue cancelada. Puedes reactivarla en cualquier momento."
        },
        "paused": {
          "title": "Suscripción pausada",
          "message": "Tu suscripción está pausada. Reactívala para continuar usando todas las funciones."
        },
        "trial_expired": {
          "title": "Período de prueba terminado",
          "message": "Tu período de prueba ha terminado. Suscríbete para continuar usando todas las funciones."
        },
        "button": "Gestionar suscripción"
      },
      "devices": {
        "title": "Gestión de Dispositivos",
        "description": "Administra los dispositivos conectados a tu cuenta",
        "lastAccessed": "Último acceso",
        "on": "en",
        "buttons": {
          "logout": "Cerrar sesión",
          "currentDevice": "Dispositivo actual"
        },
        "forms": {
          "edit": {
            "status": {
              "loading": {
                "title": "Cerrando sesión en dispositivo",
                "message": "Por favor espere mientras cerramos la sesión en este dispositivo..."
              },
              "success": {
                "title": "Sesión cerrada",
                "message": "La sesión en el dispositivo ha sido cerrada exitosamente"
              },
              "error": {
                "title": "Error al cerrar sesión",
                "message": "Ocurrió un error al cerrar la sesión en el dispositivo"
              }
            }
          },
          "create": {
            "title": "Crear nuevo dispositivo",
            "description": "Crear un nuevo dispositivo",
            "fields": {
              "name": {
                "label": "Nombre del dispositivo",
                "placeholder": "Ingresa el nombre del dispositivo"
              },
              "userAgent": {
                "label": "User Agent",
                "placeholder": "Ingresa el User Agent"
              }
            }
          }
        }
      },
      "profile": {
        "forms": {
          "update": {
            "title": "Actualizar perfil",
            "description": "Modifica tu información personal",
            "fields": {
              "firstName": {
                "label": "Nombre completo",
                "placeholder": "Ingresa tu nombre"
              },
              "lastName": {
                "label": "Apellido completo",
                "placeholder": "Ingresa tu apellido"
              },
              "phoneNumber": {
                "label": "Número de teléfono completo",
                "placeholder": "Ingresa tu número de teléfono"
              },
              "photo": {
                "label": "Foto de perfil"
              }
            },
            "status": {
              "loading": {
                "title": "Actualizando perfil",
                "message": "Por favor espere mientras actualizamos su perfil..."
              },
              "success": {
                "title": "Perfil actualizado",
                "message": "Su perfil ha sido actualizado exitosamente"
              },
              "error": {
                "title": "Error al actualizar perfil",
                "message": "Ocurrió un error al actualizar su perfil"
              }
            }
          },
          "changeEmail": {
            "title": "Cambiar Correo Electrónico",
            "description": "Actualiza tu dirección de correo electrónico",
            "fields": {
              "currentPassword": {
                "label": "Contraseña actual",
                "placeholder": "Ingresa tu contraseña actual"
              },
              "newEmail": {
                "label": "Nuevo correo electrónico",
                "placeholder": "Ingresa tu nuevo correo"
              }
            },
            "status": {
              "loading": {
                "title": "Cambiando correo electrónico",
                "message": "Por favor espere mientras procesamos el cambio..."
              },
              "success": {
                "title": "Correo electrónico actualizado",
                "message": "Su correo electrónico ha sido actualizado exitosamente"
              },
              "error": {
                "title": "Error al cambiar correo",
                "message": "Ocurrió un error al cambiar su correo electrónico"
              }
            }
          },
          "changePassword": {
            "title": "Cambiar Contraseña",
            "description": "Actualiza tu contraseña de acceso",
            "fields": {
              "currentPassword": {
                "label": "Contraseña actual",
                "placeholder": "Ingresa tu contraseña actual"
              },
              "newPassword": {
                "label": "Nueva contraseña",
                "placeholder": "Ingresa tu nueva contraseña"
              },
              "confirmPassword": {
                "label": "Confirmar nueva contraseña",
                "placeholder": "Confirma tu nueva contraseña"
              }
            },
            "status": {
              "loading": {
                "title": "Cambiando contraseña",
                "message": "Por favor espere mientras actualizamos su contraseña..."
              },
              "success": {
                "title": "Contraseña actualizada",
                "message": "Su contraseña ha sido actualizada exitosamente"
              },
              "error": {
                "title": "Error al cambiar contraseña",
                "message": "Ocurrió un error al cambiar su contraseña"
              }
            }
          }
        }
      }
    },
    "documents": {
      "title": "Documentos",
      "table": {
        "columns": {
          "name": "Nombre",
          "size": "Tamaño",
          "created": "Fecha de creación",
          "document": "Documento",
          "search": "Buscar"
        }
      },
      "forms": {
        "create": {
          "title": "Crear documento",
          "description": "Subir un nuevo documento",
          "status": {
            "loading": {
              "title": "Creando documento",
              "message": "Por favor espere mientras creamos el documento..."
            },
            "success": {
              "title": "Documento creado",
              "message": "El documento ha sido creado exitosamente"
            },
            "error": {
              "title": "Error al crear documento",
              "message": "Ocurrió un error al crear el documento"
            }
          }
        },
        "edit": {
          "title": "Editar documento",
          "description": "Actualizar información del documento",
          "status": {
            "loading": {
              "title": "Actualizando documento",
              "message": "Por favor espere mientras actualizamos el documento..."
            },
            "success": {
              "title": "Documento actualizado",
              "message": "El documento ha sido actualizado exitosamente"
            },
            "error": {
              "title": "Error al actualizar documento",
              "message": "Ocurrió un error al actualizar el documento"
            }
          }
        },
        "fields": {
          "name": {
            "label": "Nombre del documento",
            "placeholder": "Resultados de laboratorio"
          }
        }
      }
    },
    "invitations": {
      "title": "Invitaciones",
      "description": "Gestiona las invitaciones de doctores a tu consultorio",
      "sent": {
        "title": "Invitaciones Enviadas",
        "description": "Administra las invitaciones que has enviado a otros doctores",
        "empty": "No has enviado ninguna invitación"
      },
      "received": {
        "title": "Invitaciones Recibidas",
        "description": "Revisa las invitaciones que has recibido",
        "empty": "No tienes invitaciones pendientes"
      },
      "statuses": {
        "pending": "Pendiente",
        "accepted": "Aceptada",
        "rejected": "Rechazada",
        "expired": "Expirada"
      },
      "invitedBy": "Invitado por",
      "invitedTo": "Invitado a",
      "branch": "Consultorio",
      "created": "Creada",
      "expires": "Expira",
      "buttons": {
        "accept": "Aceptar",
        "accepting": "Aceptando...",
        "reject": "Rechazar",
        "cancel": "Cancelar",
        "resend": "Reenviar",
        "invite": "Invitar Doctor"
      },
      "acceptDialog": {
        "title": "Aceptar Invitación"
      },
      "status": {
        "loading": {
          "title": "Actualizando invitación",
          "message": "Por favor espere..."
        },
        "success": {
          "title": "Invitación actualizada",
          "message": "La invitación se actualizó correctamente"
        },
        "error": {
          "title": "Error al actualizar invitación",
          "message": "Ocurrió un error al actualizar la invitación"
        }
      },
      "resend": {
        "loading": {
          "title": "Reenviando invitación",
          "message": "Por favor espere..."
        },
        "success": {
          "title": "Invitación reenviada",
          "message": "La invitación se reenvió correctamente"
        },
        "error": {
          "title": "Error al reenviar invitación",
          "message": "Ocurrió un error al reenviar la invitación"
        }
      },
      "delete": {
        "loading": {
          "title": "Cancelando invitación",
          "message": "Por favor espere..."
        },
        "success": {
          "title": "Invitación cancelada",
          "message": "La invitación se canceló correctamente"
        },
        "error": {
          "title": "Error al cancelar invitación",
          "message": "Ocurrió un error al cancelar la invitación"
        }
      },
      "forms": {
        "create": {
          "title": "Invitar Doctor",
          "description": "Envía una invitación a otro doctor para unirse a tu consultorio",
          "fields": {
            "email": {
              "label": "Email del Doctor",
              "placeholder": "Ingresa el email del doctor"
            },
            "branch": {
              "label": "Consultorio",
              "placeholder": "Selecciona un consultorio"
            },
            "message": {
              "label": "Mensaje (opcional)",
              "placeholder": "Agrega un mensaje personalizado"
            }
          },
          "buttons": {
            "submit": "Enviar Invitación",
            "submitting": "Enviando...",
            "cancel": "Cancelar"
          },
          "errors": {
            "doctorNotFound": "No se encontró un doctor con este email. El doctor debe registrarse primero.",
            "cannotInviteSelf": "No puedes invitarte a ti mismo."
          },
          "status": {
            "loading": {
              "title": "Enviando invitación",
              "message": "Por favor espere..."
            },
            "success": {
              "title": "Invitación enviada",
              "message": "La invitación se envió correctamente"
            },
            "error": {
              "title": "Error al enviar invitación",
              "message": "Ocurrió un error al enviar la invitación"
            }
          }
        }
      },
      "invitationPage": {
        "title": "¡Has sido invitado!",
        "subtitle": "Únete a {{branchName}}",
        "personalMessage": "Mensaje personal",
        "validUntil": "Válido hasta",
        "infoText": "Al aceptar esta invitación, podrás colaborar con el equipo del consultorio y acceder a todas las funciones de la plataforma.",
        "buttons": {
          "acceptInvitation": "Aceptar invitación",
          "rejectInvitation": "Rechazar invitación",
          "creatingAccount": "Creando cuenta...",
          "goToDashboard": "Ir al panel"
        },
        "loading": "Cargando invitación...",
        "notFound": {
          "title": "Invitación no encontrada",
          "description": "Esta invitación no existe o no tienes permiso para verla."
        },
        "status": {
          "accepted": {
            "title": "Invitación aceptada",
            "message": "Te has unido exitosamente a {{branchName}}!",
            "description": "Ahora puedes acceder al panel del consultorio y comenzar a colaborar con tu equipo."
          },
          "rejected": {
            "title": "Invitación rechazada",
            "message": "Esta invitación para unirte a {{branchName}} fue rechazada."
          },
          "expired": {
            "title": "Invitación expirada",
            "message": "Esta invitación para unirte a {{branchName}} ha expirado.",
            "expiredOn": "Expiró el: {{date}}",
            "description": "Por favor solicita una nueva invitación."
          }
        },
        "toast": {
          "acceptLoading": "Aceptando invitación",
          "acceptSuccess": "¡Invitación aceptada exitosamente!",
          "acceptError": "Error al aceptar invitación",
          "rejectLoading": "Rechazando invitación",
          "rejectSuccess": "¡Invitación rechazada exitosamente!",
          "rejectError": "Error al rechazar invitación"
        },
        "validation": {
          "passwordMismatch": "Las contraseñas no coinciden"
        }
      }
    },
    "marketing": {
      "nav": {
        "product": "Producto",
        "odontogram": "Odontograma",
        "pricing": "Precios",
        "login": "Iniciar sesión",
        "freeTrial": "Prueba gratis"
      },
      "themeToggle": {
        "toLight": "Cambiar a tema claro",
        "toDark": "Cambiar a tema oscuro"
      },
      "langToggle": {
        "label": "Cambiar idioma"
      },
      "hero": {
        "badge": "✦ Nuevo · Odontograma inteligente 2026",
        "titleLead": "La clínica dental,",
        "titleAccent": "por fin sin fricción.",
        "subtitle": "OdontOffice reúne agenda, historia clínica, odontograma y facturación en un solo lugar. Menos papeleo, más pacientes atendidos.",
        "ctaPrimary": "Empieza gratis 14 días",
        "ctaSecondary": "Ver demo",
        "trust": {
          "noCard": "✓ Sin tarjeta de crédito",
          "clinicsCount": "1.200+",
          "clinicsLabel": "clínicas confían",
          "ratingScore": "4.9",
          "ratingLabel": "en soporte"
        },
        "flow": {
          "ariaLabel": "Todo tu consultorio fluye hacia OdontOffice",
          "origin": "ORIGEN",
          "modules": "MÓDULOS",
          "sources": {
            "wa": "WhatsApp",
            "mail": "Correo",
            "cal": "Calendario",
            "phone": "Llamadas",
            "portal": "Portal paciente"
          },
          "destinations": {
            "agenda": "Agenda",
            "historia": "Historia clínica",
            "odonto": "Odontograma",
            "factura": "Facturación",
            "reportes": "Reportes"
          }
        }
      },
      "features": {
        "eyebrow": "Todo lo esencial",
        "title": "Una plataforma, toda tu clínica",
        "subtitle": "Deja de saltar entre agenda, Excel y WhatsApp. OdontOffice conecta cada pieza del día a día.",
        "items": {
          "agenda": {
            "title": "Agenda inteligente",
            "body": "Citas por sillón y profesional, con huecos sugeridos y confirmación automática por WhatsApp."
          },
          "odontogram": {
            "title": "Odontograma digital",
            "body": "Registra tratamientos diente a diente con historial visual y evolución en el tiempo."
          },
          "history": {
            "title": "Historia clínica",
            "body": "Alergias, radiografías, consentimientos y notas del paciente, todo en un clic."
          },
          "billing": {
            "title": "Facturación y cobros",
            "body": "Presupuestos, planes de pago y factura electrónica. Sabe qué te deben en tiempo real."
          },
          "reminders": {
            "title": "Recordatorios automáticos",
            "body": "Reduce inasistencias hasta un 40% con avisos por SMS, correo y WhatsApp."
          },
          "reports": {
            "title": "Reportes en vivo",
            "body": "Producción, ocupación de sillones y tratamientos más rentables, sin exportar nada."
          }
        }
      },
      "showcase": {
        "eyebrow": "Odontograma",
        "title": "El diente a diente, más claro que nunca",
        "subtitle": "Marca caries, restauraciones y tratamientos sobre un odontograma interactivo. Tu equipo ve la misma historia, siempre actualizada.",
        "points": {
          "p1": "Vista por cuadrantes con estado de cada pieza",
          "p2": "Adjunta radiografías y fotos por diente",
          "p3": "Genera el presupuesto desde el propio diagnóstico"
        },
        "cta": "Probar el odontograma",
        "toothTitle": "Odontograma",
        "tags": {
          "tooth16": "Pieza 16 · Sana",
          "tooth36": "Pieza 36 · Restauración",
          "budget": "Presupuesto listo"
        }
      },
      "stats": {
        "items": {
          "noShows": {
            "value": "40%",
            "label": "menos inasistencias"
          },
          "hoursSaved": {
            "value": "6 h",
            "label": "ahorradas por semana"
          },
          "clinics": {
            "value": "1.200+",
            "label": "clínicas activas"
          },
          "uptime": {
            "value": "99.9%",
            "label": "disponibilidad"
          }
        }
      },
      "testimonial": {
        "eyebrow": "Historias reales",
        "quote": "“Pasamos de tres cuadernos y un Excel a tenerlo todo en OdontOffice. Recuperamos las tardes de los viernes que se iban en cuadrar cuentas.”",
        "author": "Dra. Carolina Restrepo",
        "clinic": "Clínica Sonríe, Medellín"
      },
      "pricing": {
        "eyebrow": "Precios claros",
        "title": "Empieza gratis. Crece cuando quieras.",
        "subtitle": "30 días de prueba en todos los planes. Sin permanencia.",
        "perMonth": "/mes",
        "popularBadge": "Más elegido",
        "cta": "Probar 30 días gratis",
        "plans": {
          "starter": {
            "name": "Starter",
            "blurb": "Ideal para dentistas que comienzan.",
            "annual": "o $39/mes facturado anualmente",
            "features": {
              "f1": "1 sucursal · 1 doctor",
              "f2": "Hasta 100 pacientes",
              "f3": "30 citas por mes",
              "f4": "Odontograma básico",
              "f5": "Dashboard básico",
              "f6": "Soporte por email (48-72h)"
            }
          },
          "professional": {
            "name": "Profesional",
            "blurb": "Para consultorios establecidos.",
            "annual": "o $99/mes facturado anualmente",
            "features": {
              "f1": "Hasta 5 sucursales · 10 doctores",
              "f2": "Hasta 500 pacientes",
              "f3": "Citas ilimitadas",
              "f4": "Odontograma completo",
              "f5": "Dashboard + KPIs y tendencias",
              "f6": "Facturación avanzada",
              "f7": "Soporte prioritario (24h)"
            }
          },
          "enterprise": {
            "name": "Empresarial",
            "blurb": "Para cadenas de consultorios.",
            "annual": "o $249/mes facturado anualmente",
            "features": {
              "f1": "Sucursales y doctores ilimitados",
              "f2": "Pacientes ilimitados",
              "f3": "Todas las funciones desbloqueadas",
              "f4": "Analytics personalizados",
              "f5": "Gestor de cuenta dedicado",
              "f6": "Soporte dedicado (2-4h)"
            }
          }
        }
      },
      "finalCta": {
        "title": "Tu clínica, ordenada esta misma semana",
        "subtitle": "Configura OdontOffice en menos de 20 minutos. Migramos tus pacientes por ti, gratis.",
        "cta": "Empieza gratis"
      },
      "footer": {
        "tagline": "El software de gestión que tu clínica dental merece.",
        "columns": {
          "product": {
            "title": "Producto",
            "links": {
              "l1": "Agenda",
              "l2": "Odontograma",
              "l3": "Facturación",
              "l4": "Reportes"
            }
          },
          "company": {
            "title": "Empresa",
            "links": {
              "l1": "Sobre nosotros",
              "l2": "Clientes",
              "l3": "Blog",
              "l4": "Contacto"
            }
          },
          "resources": {
            "title": "Recursos",
            "links": {
              "l1": "Centro de ayuda",
              "l2": "Migración gratis",
              "l3": "Estado del servicio"
            }
          }
        },
        "legal": "Privacidad · Términos · Cookies"
      }
    }
  }
}
